// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: bmeeQQnB83Ri
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import MenuSelectStack from "../../MenuSelectStack"; // plasmic-import: 5NpjpkJRYPLT/component
import SearchRectangle from "../../SearchRectangle"; // plasmic-import: 8zoHL39XdeHp/component
import SubscriptionSelect from "../../SubscriptionSelect"; // plasmic-import: kmGCUq38E0wd/component
import InvoiceFields from "../../InvoiceFields"; // plasmic-import: otxlHe2K5B0H/component
import AdvancedOptionsComponent from "../../AdvancedOptionsComponent"; // plasmic-import: 6rSjFDYDzjHH/component
import Switch from "../../Switch"; // plasmic-import: g3F1mEXIUWbM/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSubscriptionDetails.module.css"; // plasmic-import: bmeeQQnB83Ri/css

createPlasmicElementProxy;

export const PlasmicSubscriptionDetails__VariantProps = new Array();

export const PlasmicSubscriptionDetails__ArgProps = new Array(
  "balanceDue",
  "companySelected",
  "emailSelected",
  "deliveryMessage"
);

const $$ = {};

function PlasmicSubscriptionDetails__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "notes.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "subscriptionSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "achSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSurchargeSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "deliverySelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__m4Fb1)}>
            <div className={classNames(projectcss.all, sty.freeBox__eS27G)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails"}
                data-plasmic-override={overrides.invoiceDetails}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___0L36Y)}
                >
                  <div
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {"Recurring Payment Details"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title3"}
                  data-plasmic-override={overrides.title3}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title3
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Client"
                    : "Client"}
                </div>
                <div
                  data-plasmic-name={"selectedClient"}
                  data-plasmic-override={overrides.selectedClient}
                  className={classNames(projectcss.all, sty.selectedClient)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox___8A8Hs)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__rrXUm
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Company"}
                            </span>
                          </React.Fragment>
                        </div>
                      ),

                      value: args.companySelected,
                      className: classNames(sty.slotTargetCompanySelected)
                    })}
                    <div
                      data-plasmic-name={"emailSelected"}
                      data-plasmic-override={overrides.emailSelected}
                      className={classNames(projectcss.all, sty.emailSelected)}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "email address",
                        value: args.emailSelected,
                        className: classNames(sty.slotTargetEmailSelected)
                      })}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"deleteSelection"}
                    data-plasmic-override={overrides.deleteSelection}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.deleteSelection
                    )}
                  >
                    {"X"}
                  </div>
                </div>
                <MenuSelectStack
                  data-plasmic-name={"menuSelectStack"}
                  data-plasmic-override={overrides.menuSelectStack}
                  className={classNames("__wab_instance", sty.menuSelectStack)}
                />

                <SearchRectangle
                  data-plasmic-name={"searchRectangle"}
                  data-plasmic-override={overrides.searchRectangle}
                  className={classNames("__wab_instance", sty.searchRectangle)}
                />

                <div
                  data-plasmic-name={"title8"}
                  data-plasmic-override={overrides.title8}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title8
                  )}
                >
                  {"Subscription Cycle"}
                </div>
                <SubscriptionSelect
                  data-plasmic-name={"subscriptionSelect"}
                  data-plasmic-override={overrides.subscriptionSelect}
                  className={classNames(
                    "__wab_instance",
                    sty.subscriptionSelect
                  )}
                  onChange={async (...eventArgs) => {
                    ((...eventArgs) => {
                      generateStateOnChangeProp($state, [
                        "subscriptionSelect",
                        "value"
                      ])(eventArgs[0]);
                    }).apply(null, eventArgs);
                    if (
                      eventArgs.length > 1 &&
                      eventArgs[1] &&
                      eventArgs[1]._plasmic_state_init_
                    ) {
                      return;
                    }
                  }}
                  options={(() => {
                    const __composite = [
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null },
                      { value: null, label: null }
                    ];

                    __composite["0"]["value"] = "Weekly";
                    __composite["0"]["label"] = "Weekly";
                    __composite["1"]["value"] = "Biweekly";
                    __composite["1"]["label"] = "Biweekly";
                    __composite["2"]["value"] = "Every 3 Weeks";
                    __composite["2"]["label"] = "Every 3 Weeks";
                    __composite["3"]["value"] = "Monthly";
                    __composite["3"]["label"] = "Monthly";
                    __composite["4"]["value"] = "Bimonthly";
                    __composite["4"]["label"] = "Bimonthly";
                    __composite["5"]["value"] = "Every 3 Months";
                    __composite["5"]["label"] = "Every 3 Months";
                    __composite["6"]["value"] = "Every 4 Months";
                    __composite["6"]["label"] = "Every 4 Months";
                    __composite["7"]["value"] = "Every 5 Months";
                    __composite["7"]["label"] = "Every 5 Months";
                    __composite["8"]["value"] = "Every 6 Months";
                    __composite["8"]["label"] = "Every 6 Months";
                    return __composite;
                  })()}
                  placeholder={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___64Dys
                      )}
                    >
                      {"Select\u2026"}
                    </div>
                  }
                  value={generateStateValueProp($state, [
                    "subscriptionSelect",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"title11"}
                  data-plasmic-override={overrides.title11}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title11
                  )}
                >
                  {"Subscription Start Date"}
                </div>
                <div
                  data-plasmic-name={"dueDate"}
                  data-plasmic-override={overrides.dueDate}
                  className={classNames(projectcss.all, sty.dueDate)}
                />

                <div
                  data-plasmic-name={"title12"}
                  data-plasmic-override={overrides.title12}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title12
                  )}
                >
                  {"Delivery"}
                </div>
                <SubscriptionSelect
                  data-plasmic-name={"deliverySelect"}
                  data-plasmic-override={overrides.deliverySelect}
                  className={classNames("__wab_instance", sty.deliverySelect)}
                  onChange={async (...eventArgs) => {
                    ((...eventArgs) => {
                      generateStateOnChangeProp($state, [
                        "deliverySelect",
                        "value"
                      ])(eventArgs[0]);
                    }).apply(null, eventArgs);
                    if (
                      eventArgs.length > 1 &&
                      eventArgs[1] &&
                      eventArgs[1]._plasmic_state_init_
                    ) {
                      return;
                    }
                  }}
                  options={
                    hasVariant(globalVariants, "screen", "medium")
                      ? (() => {
                          const __composite = [
                            { value: null, label: null },
                            { value: null, label: null }
                          ];

                          __composite["0"]["value"] = "email";
                          __composite["0"]["label"] =
                            "Email invoice to customer";
                          __composite["1"]["value"] = "no_email";
                          __composite["1"]["label"] =
                            "Do not email invoice to customer";
                          return __composite;
                        })()
                      : (() => {
                          const __composite = [
                            { value: null, label: null },
                            { value: null, label: null }
                          ];

                          __composite["0"]["value"] = "email";
                          __composite["0"]["label"] =
                            "Email invoice to customer";
                          __composite["1"]["value"] = "no_email";
                          __composite["1"]["label"] =
                            "Do not email invoice to customer";
                          return __composite;
                        })()
                  }
                  placeholder={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__rzY5S
                      )}
                    >
                      {"Select\u2026"}
                    </div>
                  }
                  value={generateStateValueProp($state, [
                    "deliverySelect",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"deliveryStack"}
                  data-plasmic-override={overrides.deliveryStack}
                  className={classNames(projectcss.all, sty.deliveryStack)}
                >
                  {renderPlasmicSlot({
                    defaultContents:
                      "Payment link will still be created to send manually",
                    value: args.deliveryMessage,
                    className: classNames(sty.slotTargetDeliveryMessage)
                  })}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__kziKz)}>
                  <div
                    data-plasmic-name={"title2"}
                    data-plasmic-override={overrides.title2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title2
                    )}
                  >
                    {"Item"}
                  </div>
                  <div
                    data-plasmic-name={"title5"}
                    data-plasmic-override={overrides.title5}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title5
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "medium")
                      ? "Quantity"
                      : "Quantity"}
                  </div>
                  <div
                    data-plasmic-name={"title6"}
                    data-plasmic-override={overrides.title6}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title6
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "medium")
                      ? "Price"
                      : "Price"}
                  </div>
                </div>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"invoiceStack"}
                  data-plasmic-override={overrides.invoiceStack}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.invoiceStack)}
                >
                  <InvoiceFields
                    data-plasmic-name={"invoiceFields"}
                    data-plasmic-override={overrides.invoiceFields}
                    className={classNames("__wab_instance", sty.invoiceFields)}
                  />
                </Stack__>
                <div className={classNames(projectcss.all, sty.freeBox__skKHy)}>
                  <div
                    data-plasmic-name={"addItem"}
                    data-plasmic-override={overrides.addItem}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.addItem
                    )}
                  >
                    {"Add Item"}
                  </div>
                  <div
                    data-plasmic-name={"title9"}
                    data-plasmic-override={overrides.title9}
                    className={classNames(projectcss.all, sty.title9)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "Balance Due: $0.00",
                      value: args.balanceDue,
                      className: classNames(sty.slotTargetBalanceDue)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title10"}
                  data-plasmic-override={overrides.title10}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title10
                  )}
                >
                  {"Notes/Terms (optional)"}
                </div>
                <textarea
                  data-plasmic-name={"notes"}
                  data-plasmic-override={overrides.notes}
                  className={classNames(
                    projectcss.all,
                    projectcss.textarea,
                    sty.notes
                  )}
                  onChange={async (...eventArgs) => {
                    (e => {
                      generateStateOnChangeProp($state, ["notes", "value"])(
                        e.target.value
                      );
                    }).apply(null, eventArgs);
                  }}
                  ref={ref => {
                    $refs["notes"] = ref;
                  }}
                  value={
                    generateStateValueProp($state, ["notes", "value"]) ?? ""
                  }
                />
              </Stack__>
              <div className={classNames(projectcss.all, sty.freeBox__axs72)}>
                <AdvancedOptionsComponent
                  data-plasmic-name={"advancedOptionsInstance"}
                  data-plasmic-override={overrides.advancedOptionsInstance}
                  className={classNames(
                    "__wab_instance",
                    sty.advancedOptionsInstance
                  )}
                />

                <div
                  data-plasmic-name={"advancedOptionsStack"}
                  data-plasmic-override={overrides.advancedOptionsStack}
                  className={classNames(
                    projectcss.all,
                    sty.advancedOptionsStack
                  )}
                >
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__gwgBs)}
                  >
                    <div
                      data-plasmic-name={"title26"}
                      data-plasmic-override={overrides.title26}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title26
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Payment Methods"
                        : "Payment Methods"}
                    </div>
                    <Switch
                      data-plasmic-name={"achSwitch"}
                      data-plasmic-override={overrides.achSwitch}
                      className={classNames("__wab_instance", sty.achSwitch)}
                      isChecked={
                        generateStateValueProp($state, [
                          "achSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "achSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___3UDij
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "medium")
                          ? "ACH"
                          : "ACH"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSwitch"}
                      data-plasmic-override={overrides.cardSwitch}
                      className={classNames("__wab_instance", sty.cardSwitch)}
                      isChecked={
                        generateStateValueProp($state, [
                          "cardSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "cardSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__dmpXd
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "medium")
                          ? "Card"
                          : "Card"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSurchargeSwitch"}
                      data-plasmic-override={overrides.cardSurchargeSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.cardSurchargeSwitch
                      )}
                      isChecked={
                        generateStateValueProp($state, [
                          "cardSurchargeSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={async (...eventArgs) => {
                        ((...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "cardSurchargeSwitch",
                            "isChecked"
                          ])(eventArgs[0]);
                        }).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___5OlSb
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "small")
                          ? "Card (pass fee to client)"
                          : hasVariant(globalVariants, "screen", "medium")
                          ? "Card (pass fee to  client)"
                          : "Card (pass fee to client)"}
                      </div>
                    </Switch>
                  </Stack__>
                </div>
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {"Please enter all of the required fields"}
              </div>
              <div
                data-plasmic-name={"sendButton"}
                data-plasmic-override={overrides.sendButton}
                className={classNames(projectcss.all, sty.sendButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___533Yc
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Review and Send"
                    : "Review"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "invoiceDetails",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "menuSelectStack",
    "searchRectangle",
    "title8",
    "subscriptionSelect",
    "title11",
    "dueDate",
    "title12",
    "deliverySelect",
    "deliveryStack",
    "title2",
    "title5",
    "title6",
    "invoiceStack",
    "invoiceFields",
    "addItem",
    "title9",
    "title10",
    "notes",
    "advancedOptionsInstance",
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "cardSurchargeSwitch",
    "errorText",
    "sendButton"
  ],

  sidebar: ["sidebar"],
  invoiceDetails: [
    "invoiceDetails",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "menuSelectStack",
    "searchRectangle",
    "title8",
    "subscriptionSelect",
    "title11",
    "dueDate",
    "title12",
    "deliverySelect",
    "deliveryStack",
    "title2",
    "title5",
    "title6",
    "invoiceStack",
    "invoiceFields",
    "addItem",
    "title9",
    "title10",
    "notes"
  ],

  title4: ["title4"],
  title3: ["title3"],
  selectedClient: ["selectedClient", "emailSelected", "deleteSelection"],
  emailSelected: ["emailSelected"],
  deleteSelection: ["deleteSelection"],
  menuSelectStack: ["menuSelectStack"],
  searchRectangle: ["searchRectangle"],
  title8: ["title8"],
  subscriptionSelect: ["subscriptionSelect"],
  title11: ["title11"],
  dueDate: ["dueDate"],
  title12: ["title12"],
  deliverySelect: ["deliverySelect"],
  deliveryStack: ["deliveryStack"],
  title2: ["title2"],
  title5: ["title5"],
  title6: ["title6"],
  invoiceStack: ["invoiceStack", "invoiceFields"],
  invoiceFields: ["invoiceFields"],
  addItem: ["addItem"],
  title9: ["title9"],
  title10: ["title10"],
  notes: ["notes"],
  advancedOptionsInstance: ["advancedOptionsInstance"],
  advancedOptionsStack: [
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "cardSurchargeSwitch"
  ],

  title26: ["title26"],
  achSwitch: ["achSwitch"],
  cardSwitch: ["cardSwitch"],
  cardSurchargeSwitch: ["cardSurchargeSwitch"],
  errorText: ["errorText"],
  sendButton: ["sendButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSubscriptionDetails__ArgProps,
          internalVariantPropNames: PlasmicSubscriptionDetails__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSubscriptionDetails__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSubscriptionDetails";
  } else {
    func.displayName = `PlasmicSubscriptionDetails.${nodeName}`;
  }
  return func;
}

export const PlasmicSubscriptionDetails = Object.assign(
  // Top-level PlasmicSubscriptionDetails renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    invoiceDetails: makeNodeComponent("invoiceDetails"),
    title4: makeNodeComponent("title4"),
    title3: makeNodeComponent("title3"),
    selectedClient: makeNodeComponent("selectedClient"),
    emailSelected: makeNodeComponent("emailSelected"),
    deleteSelection: makeNodeComponent("deleteSelection"),
    menuSelectStack: makeNodeComponent("menuSelectStack"),
    searchRectangle: makeNodeComponent("searchRectangle"),
    title8: makeNodeComponent("title8"),
    subscriptionSelect: makeNodeComponent("subscriptionSelect"),
    title11: makeNodeComponent("title11"),
    dueDate: makeNodeComponent("dueDate"),
    title12: makeNodeComponent("title12"),
    deliverySelect: makeNodeComponent("deliverySelect"),
    deliveryStack: makeNodeComponent("deliveryStack"),
    title2: makeNodeComponent("title2"),
    title5: makeNodeComponent("title5"),
    title6: makeNodeComponent("title6"),
    invoiceStack: makeNodeComponent("invoiceStack"),
    invoiceFields: makeNodeComponent("invoiceFields"),
    addItem: makeNodeComponent("addItem"),
    title9: makeNodeComponent("title9"),
    title10: makeNodeComponent("title10"),
    notes: makeNodeComponent("notes"),
    advancedOptionsInstance: makeNodeComponent("advancedOptionsInstance"),
    advancedOptionsStack: makeNodeComponent("advancedOptionsStack"),
    title26: makeNodeComponent("title26"),
    achSwitch: makeNodeComponent("achSwitch"),
    cardSwitch: makeNodeComponent("cardSwitch"),
    cardSurchargeSwitch: makeNodeComponent("cardSurchargeSwitch"),
    errorText: makeNodeComponent("errorText"),
    sendButton: makeNodeComponent("sendButton"),
    // Metadata about props expected for PlasmicSubscriptionDetails
    internalVariantProps: PlasmicSubscriptionDetails__VariantProps,
    internalArgProps: PlasmicSubscriptionDetails__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicSubscriptionDetails;
/* prettier-ignore-end */
